if (!customElements.get('card-product-selector')) {
  class CardProductSelector extends ProductSelector {
    constructor() {
      super();

      this.cardWrapper = this.closest('[data-card-product]');
      this.images = this.cardWrapper.querySelectorAll('[data-card-image]');
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      if (event.target.type === 'number' || !this.currentVariant) {
        return;
      }

      this.updateImage();
    }

    updateImage() {
      this.images.forEach((image) => {
        image.classList.remove('is-active');

        const matchesVariant = image.dataset.variants?.includes(
          this.currentVariant.id,
        );

        if (!matchesVariant) return;

        image.classList.add('is-active');
      });
    }
  }

  customElements.define('card-product-selector', CardProductSelector);
}
